import React from 'react';

interface NoAppCardProps {
  onCreate: () => void;
  onLink: () => void;
  onDismiss: () => void;
}

/**
 * Center CTA shown in the AppPanel when there is no app linked.
 * Uses the same polished glass/dark design system as the Create Agent wizard.
 * Persistent card - no dismiss option shown.
 */
export default function NoAppCard({ onCreate, onLink }: NoAppCardProps) {
  return (
    <div className="w-full h-full flex flex-col items-center justify-center p-6">
      <div className="w-full max-w-md bg-[#1e293b]/90 backdrop-blur-xl border border-white/10 rounded-2xl p-8 shadow-[0_8px_32px_rgba(0,0,0,0.4)]">
        <div className="flex flex-col items-center">
          {/* Link icon with subtle glow */}
          <div className="w-14 h-14 rounded-2xl bg-[#208AEC]/15 flex items-center justify-center shadow-[0_0_20px_rgba(32,138,236,0.2)]">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              className="text-[#208AEC]"
            >
              <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
              <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
            </svg>
          </div>

          <h2 className="mt-5 text-lg font-semibold text-white text-center font-sora tracking-tight">
            Link an app
          </h2>

          <p className="mt-2 text-sm text-white/55 text-center leading-relaxed">
            Get a frontend and backend for your agent.
          </p>
        </div>

        {/* Action buttons */}
        <div className="mt-6 flex flex-col gap-2.5">
          <button
            className="w-full px-4 py-3 rounded-xl text-white font-medium shadow-[0_0_16px_rgba(39,174,96,0.3)] hover:shadow-[0_0_24px_rgba(39,174,96,0.5)] transform hover:scale-[1.01] transition-all duration-200"
            type="button"
            onClick={onCreate}
            style={{ backgroundColor: '#27AE60' }}
            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#19875F'; }}
            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#27AE60'; }}
          >
            Create app
          </button>

          <button
            className="w-full px-4 py-3 rounded-xl bg-white/5 border border-white/10 hover:bg-white/10 hover:border-white/20 text-white/80 font-medium transition-all duration-200"
            type="button"
            onClick={onLink}
          >
            Link existing
          </button>
        </div>
      </div>
    </div>
  );
}
